import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * NQ DataCard — a titled panel (positions, allocation, comparison sections).
 * Shared primitive: consistent card chrome across surfaces.
 */
export function DataCard({
  title,
  action,
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { title?: string; action?: React.ReactNode }) {
  return (
    <div className={cn('rounded-2xl border border-border bg-card p-5', className)} {...props}>
      {(title || action) && (
        <div className="mb-3 flex items-center justify-between">
          {title && <h3 className="font-display text-base font-semibold">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
